<div class="change-request-list">
  <ng-container *ngIf="netChanges$ | async as netChanges">
    <ng-container *ngIf="netChanges.deliverables.length || netChanges.sections.length; else noChanges">
      <scope-by-work-table
        [scopeVersion]="currentScope"
        [currentChangeRequest]="currentChangeRequest"
        [isEditable]="false"
        [showNetChanges]="true"
        [mainColumnClass]="mainColumnClass"
        [componentMainColumnClass]="componentMainColumnClass"
        [roleMainColumnClass]="roleMainColumnClass"
        [sortedSections]="netChanges.sections"
        [sortedDefaultSectionDeliverables]="netChanges.deliverables"
        [cdnConfig]="cdnConfig" />
    </ng-container>
  </ng-container>

  <ng-template #noChanges>
    <div class="no-changes">
      <mat-icon class="material-symbols-rounded">info</mat-icon>
      <span>No net changes to display</span>
    </div>
  </ng-template>
</div>
